export interface DocumentCountersData {
	// Obligatoires
	id: number;
	// Champs simples
	documentType: string;
	year?: number;
	lastNumber?: number;
	// Metadata
	updatedAt?: Date;
}

// Simple mapping pour traduire les codes types de documents en noms lisibles
export const documentTypeNames: { [key: string]: string } = {
	DEV: 'Devis',
	DEF: 'Devis Formation',
	COM: 'Commande',
	AV: 'Avoir',
	AC: 'Acompte',
	FC: 'Facture Client',
	FF: 'Facture Fournisseur',
};
